import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    pointTitle: 'heading-m-regular',
    pointPrefix: 'capitalize',
    pointAddress: 'heading-s mt-2',
    pointDeliveryDate: 'heading-s mt-1',
    pointHeading: 'heading-s-regular mt-3',
    pointValue: 'heading-s mt-2',
    pointConfirm: 'mt-5 w-full',
    pointConfirmBtn: 'heading-m-regular w-full',
    pointStockBtn: 'heading-m-regular w-full',
    stockInfo: 'heading-s text-accent mt-3',
    btnMore: 'heading-xs hover:text-accent mt-5 uppercase',
    imageWrapper: 'my-5 flex aspect-[341/218] w-full items-center overflow-hidden',
    image: 'h-auto w-full object-cover'
  },
  variants: {
    type: {
      simple: {},
      pdp: {}
    },
    isPhone: {
      true: {}
    }
  },
  compoundVariants: [
    {
      isPhone: true,
      type: 'simple',
      className: {
        pointValue: 'text-accent heading-s-regular underline'
      }
    }
  ]
});
